export default __webpack_public_path__ + "2a06b8588d0aac0dcd5d6aa628fd57a8.png";